import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ImageComponent } from "./image.component";

export { ImageComponent } from "./image.component";

/**
 * @ignore
 */
@NgModule({
  declarations: [ImageComponent],
  imports: [CommonModule],
  exports: [ImageComponent]
})
export class ImageBaseModule {}
